export enum SkinComponentType {
	GridContainer = "GridContainer"
}
